var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorpicker-button",class:{
    _active: _vm.waitClick,
    _disabled: _vm.disabled,
    '_gray-4': _vm.viewType === 'gray-4',
    '_gray-5': _vm.viewType === 'gray-5',
  },attrs:{"title":!_vm.disabled ? '' : 'Color management not available'},on:{"click":function($event){$event.stopPropagation();return _vm.startPicker($event)}}},[_c('div',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }